import React, { Component } from "react";
import "./i18n";
import { withTranslation } from "react-i18next";
import Tabs from "./Components/Tabs";
import ResetPassword from "./Components/ResetPassword";
import SuccessMessage from "./Components/SuccessMessage";
import getParameter from "./util";
import { verifyClient } from "./api/api"
import * as CONSTANTS from "./constants";

class App extends Component {
  constructor(props) {
    super(props);

    let uuid = getParameter("uuid");
    // console.log("App :: constructor => uuid: [" + uuid + "]");

    this.state = {
      isConsumer: true,
      isThirdParty: false,
      clientId: "",
      redirectURL: "",
      clientInfo: "",
      messageDetails: false,
      showSuccessMsg: false,
      transactionId: uuid,
      showResetPassword:
        window.location.href.indexOf("reset") > -1 &&
          getParameter("uuid") != null &&
          getParameter("uuid") != ""
          ? true
          : false,
    };
  }

  async componentDidMount() {
    let clientId = getParameter("client_id");
    // console.log("ForgotAccount :: componentDidMount :: client Id => " + clientId);

    let redirectURL = getParameter("redirect_url");
    // console.log("ForgotAccount :: componentDidMount :: redirect_url => " + redirectURL);

    let accountType = getParameter("account_type");
    // console.log("ForgotAccount :: Render :: Account Type as Param => " + accountType);

    if (accountType === null) {
      accountType = "personal"
    }

    if (redirectURL === null) {
      redirectURL = '/wps/portal/web';
    }

    if (clientId === null || clientId === "" || clientId === 'EPORTAL') {
      clientId = window.OAUTHUserName;
    }
    await this.verifyClient(clientId, redirectURL, accountType);
  }

  verifyClient = async (clientId, redirectURL, accountType) => {
    // console.log("ForgotAccount :: verifyClient :: Enter");
    // console.log("ForgotAccount :: verifyClient :: clientId => " + clientId);
    // console.log("ForgotAccount :: verifyClient :: redirectURL => " + redirectURL);
    // console.log("ForgotAccount :: verifyClient :: accountType => " + accountType);

    let requestBody = {
      "clientId": clientId
    }

    // console.log("ForgotAccount :: verifyClient :: requestBody => " + JSON.stringify(requestBody));

    await this.setState({
      loading: true
    })

    try {
      let result = await verifyClient(requestBody);
      // console.log("ForgotAccount :: verifyClient :: result => " + JSON.stringify(result));

      //CHECK ACCOUNT TYPE IF THE CLIENT IS EPORTAL
      let isConsumer = true

      if (clientId === window.OAUTHUserName) {
        // console.log("ForgotAccount :: verifyClient :: Client is Eportal");
        this.setState({ isThirdParty: false });

        if (accountType === 'personal') {
          isConsumer = true
        } else if (accountType === 'business') {
          isConsumer = false
        }
      } else {
        // console.log("ForgotAccount :: verifyClient :: Client is not Eportal");
        this.setState({ isThirdParty: true });

        if (result.uiClientForms && result.uiClientForms[CONSTANTS.USER_TYPE_INDIVIDUAL] === 'Y') {
          isConsumer = true
        } else if (result.uiClientForms && result.uiClientForms[CONSTANTS.USER_TYPE_CORPORATE] === 'Y') {
          isConsumer = false
        }
      }
      // console.log("ForgotAccount :: Render ::isConsumer => " + JSON.stringify(isConsumer));


      this.setState({
        clientInfo: result.uiClientForms,
        clientId: clientId,
        redirectURL: redirectURL,
        loading: false,
        isConsumer: isConsumer,
      })
    } catch (error) {
      console.log("ForgotAccount :: verifyClient :: Error => " + error)
      this.setState({
        genericError: error.message,
        loading: false
      })
    }
  }
  setMessageDetails = (param) => {
    this.setState({ messageDetails: param });
  };

  setShowSuccessMsg = (param) => {
    this.setState({
      showSuccessMsg: param,
    });
  };

  render() {
    return (
      <div className="App">
        {this.state.loading && <div className="loading">Loading&#8230;</div>}
        <div className="loginPage">
          {this.state.showResetPassword && this.state.transactionId != null && this.state.clientInfo != "" && (
            <ResetPassword
              transactionId={this.state.transactionId}
              setShowSuccessMsg={this.setShowSuccessMsg}
              setMessageDetails={this.setMessageDetails}
              clientId={this.state.clientId}
              redirectURL={this.state.redirectURL}
              clientInfo={this.state.clientInfo}
              isThirdParty={this.state.isThirdParty}
              isConsumer={this.state.isConsumer}
            />
          )}
          {!this.state.showResetPassword && !this.state.showSuccessMsg && this.state.clientInfo != "" && (
            <Tabs
              setShowSuccessMsg={this.setShowSuccessMsg}
              setMessageDetails={this.setMessageDetails}
              clientId={this.state.clientId}
              redirectURL={this.state.redirectURL}
              clientInfo={this.state.clientInfo}
              isThirdParty={this.state.isThirdParty}
              isConsumer={this.state.isConsumer}
            />
          )}
          {this.state.showSuccessMsg && (
            <div
              className="loginPage"
              style={
                this.state.showResetPassword && this.state.transactionId != null
                  ? { margin: "135px", width: "35%" }
                  : {}
              }
            >
              <section className="login_form">
                <SuccessMessage isThirdParty={this.state.isThirdParty} messageDetails={this.state.messageDetails} />{" "}
              </section>
            </div>
          )}
        </div>
      </div>
    );
  }
}
export default withTranslation()(App);
